export default __webpack_public_path__ + "static/psm-2-61b33ff7e5bfc97d7c77606169a49e3a.png";